export const ScrollsPopupStages = {
    create: 'create',
    copy: 'copy',
    edit: 'edit',
    add: 'add',
    watch: 'watch'
};
export const editFirmListsRight = 33554432;
